import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { startUpdateWatch } from './app/updates';
import './i18n';
import './styles.css';
import { router } from './app/router';
import { AppProvider } from './app/state';

startUpdateWatch();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppProvider>
      <RouterProvider router={router} />
    </AppProvider>
  </StrictMode>,
);
